// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-container {\n  /*background: #fff;*/\n  padding: 5px 10px;\n  margin: 0px;\n}\n.pagination-container .el-input__inner {\n    padding: 0 10px !important;\n}\n.pagination-container.hidden {\n  display: none;\n}\n.mini {\n  font-size: 12px !important;\n}\n", ""]);
// Exports
module.exports = exports;
